import './App.css';
import Router from './setup/routes-manager';

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
